module.exports = __webpack_public_path__ + "twitter.png";